import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'stringArray'
})
export class StringArrayPipe implements PipeTransform {
  transform(options: any): string[] {
    if (!options || !_.isObject(options)) {
      return [];
    }

    return Object.values(options);
  }
}
